import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { t } from 'i18next';
import {
  AccessTimeFilled,
  PersonAdd,
  CheckCircle,
  Flag,
  Warning,
  EditNote,
  Cancel,
  HourglassTop,
  NoteAdd,
  Timelapse,
  ShowChart,
} from '@mui/icons-material';

type ChartTitleType =
  | 'openedVsCompletedTasks'
  | 'taskMinutes'
  | 'averageTaskMinutes'
  | 'assignedTask'
  | 'completedTasks'
  | 'taskByPriority'
  | 'urgentTasks'
  | 'highPriorityTasks'
  | 'overdueTasks'
  | 'mediumPriorityTasks'
  | 'lowPriorityTasks'
  | 'uniqueTaskEdits'
  | 'prematurelyClosedTasks'
  | 'openTasks'
  | 'createdTasks';

const getChartTitleIcon = (title: ChartTitleType) => {
  switch (title) {
    case 'openedVsCompletedTasks':
      return <ShowChart color='primary' />;
    case 'taskMinutes':
      return <AccessTimeFilled color='primary' />;
    case 'averageTaskMinutes':
      return <Timelapse color='primary' />;
    case 'assignedTask':
      return <PersonAdd color='primary' />;
    case 'completedTasks':
      return <CheckCircle color='success' />;
    case 'taskByPriority':
      return <Flag color='primary' />;
    case 'overdueTasks':
      return <Warning color='warning' />;
    case 'urgentTasks':
      return <Flag color='error' sx={{ height: '32px', width: '32px' }} />;
    case 'highPriorityTasks':
      return <Flag color='warning' />;
    case 'mediumPriorityTasks':
      return <Flag color='info' />;
    case 'lowPriorityTasks':
      return <Flag color='primary' />;
    case 'uniqueTaskEdits':
      return <EditNote color='primary' />;
    case 'prematurelyClosedTasks':
      return <Cancel color='error' />;
    case 'openTasks':
      return <HourglassTop color='primary' />;
    case 'createdTasks':
      return <NoteAdd color='primary' />;
    default: {
      return '';
    }
  }
};

interface ChartTitleProps {
  title: ChartTitleType;
}

export const ChartTitle: FC<ChartTitleProps> = ({ title }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {getChartTitleIcon(title)}
      <Typography variant='subtitle1' sx={{ fontWeight: '500' }}>
        {t(`dashboard.charts.titles.${title}`)}
      </Typography>
    </Box>
  );
};
